<div [formGroup]="form"
     class="flex-col gap-16">
    <div class="flex-col gap-8">
        <label>{{ 'COMMON.NAME'|translate }} <span class="required">*</span></label>
        <input class="ui-input ui-input-40"
               formControlName="name">
    </div>

    <div class="flex-col gap-8">
        <label>{{ 'FLOW_CHART.NODES.TRIM.START'|translate }} <span class="required">*</span></label>
        <input formControlName="start"
               class="ui-input ui-input-40"
               type="number"
               min="0" />
    </div>

    <div class="flex-col gap-8">
        <label>{{ 'FLOW_CHART.NODES.TRIM.END'|translate }} <span class="required">*</span></label>
        <input formControlName="end"
               class="ui-input ui-input-40"
               type="number"
               min="0" />
    </div>

    <div class="flex-col gap-8">
        <label>{{ 'FLOW_CHART.NODES.TRIM.PAD'|translate }}</label>
        <input formControlName="pad"
               class="ui-input ui-input-40"
               type="number"
               min="0" />
    </div>
</div>